export default __webpack_public_path__ + "static/6-b8c19b5332ba6ef2b38a664ce300bfec.jpg";